module.exports = __webpack_public_path__ + "img/carte_bancaire.430ef996.svg";